<div
	class="hero"
	[style.--bg-mobile]="(imageMobile && 'url(' + imageMobile + ')') || null"
	[style.--bg-desktop]="(imageDesktop && 'url(' + imageDesktop + ')') || null"
>
	<div class="h-100 d-flex flex-column justify-content-center align-items-start container-xxl">
		<!-- [style.backgroundImage]="(isMobile ? imageMobile : imageDesktop) ? 'url(' + (isMobile ? imageMobile : imageDesktop) + ')' : null" -->
		@if (title) {
			<h2 class="hero__title w-100 text-truncate">{{ title }}</h2>
		}
		@if (subtitle) {
			<h3 class="hero__subtitle w-100 text-truncate">{{ subtitle }}</h3>
		}
	</div>
</div>